<template>
  <EmptySection />
</template>

<script>
import EmptySection from '@/components/content/education/courses/CourseBookEmptySection.vue'

export default {
  name: 'ContentCourseTest',
  components: { EmptySection }
}
</script>

<style scoped>

</style>
